import { Outlet } from 'react-router-dom';

const Main = () => (
  <main className="grow flex flex-col">
    <Outlet />
  </main>
);

export default Main;
